var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlockicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.67,
    height: 33.269,
    viewBox: "0 0 21.67 33.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4838",
    "data-name": "Rectangle 4838",
    width: 21.67,
    height: 33.269,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12314",
    "data-name": "Group 12314",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12313",
    "data-name": "Group 12313",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38151",
    "data-name": "Path 38151",
    d: "M0,13.788v9.74c0,5.379,4.851,9.741,10.835,9.741S21.67,28.907,21.67,23.528v-9.74Zm11.535,8.539v3.509h-1.4V22.322a1.928,1.928,0,1,1,1.4,0m7.862-9.7h-2V8.561a6.562,6.562,0,0,0-13.124,0V12.62h-2V8.561a8.562,8.562,0,0,1,17.124,0Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockicon);
export default __webpack_public_path__ + "static/media/Padlock icon.6da09f42f9350311433829221718e607.svg";
export { ForwardRef as ReactComponent };